module.exports = __webpack_public_path__ + "static/media/weld_inspect_6.d054db05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/weld_inspect_6.jpg
// module id = 1875
// module chunks = 0